import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const DropdownMenuStyle = {
  index: (visible: boolean) => css`
    display: ${visible ? "inline-block" : "none"};
    position: absolute;
    z-index: 3;
    color: #fff;
    border: 1px solid ${theme.colors.orange[200]};
    white-space: nowrap;
    left: 50%;
    transform: translateX(-50%);
    background: #010d23;
    list-style: none;
    margin: 0 auto;
    width: max-content;
    min-width: 100%;

    &::before {
      content: "";
      position: absolute;
      top: -5px;
      left: 50%;
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 3.5px 5px 3.5px;
      border-color: transparent transparent ${theme.colors.orange[200]}
        transparent;
    }
  `,
  itemMenu: css`
    position: relative;
    height: 30px;
    padding: 0 15px;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    &:hover {
      background: ${theme.colors.orange[200]};
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 6px;
      object-fit: contain;
    }

    span {
      font-size: 12px;
      line-height: 30px;
    }
  `,
};
